import type { SessionView } from '@/api/hooks/shared/useSession'
import { decodeClaims, getAccessToken } from '@/auth/oidc'
import { isAgent } from '@/data/types'

/** Lab realtime-invalidated status (invalidRealTimeBet → revalidRealTimeBet). */
export const RT_INVALID_BET_STATUS = 'RT_INVALID_BET'

/** Console-eligible hierarchy depths (Triple Master → Master). Level 1 = CM (blocked). */
const WORKSTATION_BET_CONTROL_LEVELS = new Set(['2', '3', '4', '5'])

/**
 * Workstation invalid/revalidate — legacy Backend-UI was CompanyMaster-only.
 * Strix console blocks CM (level 1); agent tiers 2–5 get the same controls.
 */
export function canManageWorkstationInvalidBets(sessionView: SessionView | undefined): boolean {
  const claims = decodeClaims(getAccessToken())
  if (claims?.hierarchyLevel && WORKSTATION_BET_CONTROL_LEVELS.has(claims.hierarchyLevel)) {
    return true
  }

  const jwtRoles = (claims?.roles ?? []).map((r) => r.toLowerCase())
  if (jwtRoles.includes('ops') || jwtRoles.includes('risk-desk')) return true

  if (!sessionView) return false

  const { account, session } = sessionView
  if (session.scopes.includes('ops') || session.scopes.includes('risk-desk')) return true
  return isAgent(account.role)
}

/** Old bet-breakdown.html: revalidate icon for RT_INVALID_BET, not Match Odds. */
export function canRevalidateWorkstationBet(bet: {
  status: string
  marketName: string
}): boolean {
  return bet.status === RT_INVALID_BET_STATUS && bet.marketName !== 'Match Odds'
}

/** Old bet-breakdown.html: invalid checkbox when not RT_INVALID_BET, not Match Odds. */
export function canSelectBetForInvalid(bet: { status: string; marketName: string }): boolean {
  return bet.status !== RT_INVALID_BET_STATUS && bet.marketName !== 'Match Odds'
}
